<div class="panel-messagebox">
    <h1 class="panel-messagebox-title">{{ 'CookieConsent.DialogTitle' | translate }}</h1>
    <p>
        {{ 'CookieConsent.DialogMessage' | translate }} <a href="{{ 'CookieConsent.TermsOfServiceLink' | translate }}"
            target="_blank">{{
            'CookieConsent.TermsOfService' | translate
            }}</a>.
    </p>
    <p>
        {{ 'CookieConsent.WithdrawAnyTime' | translate }}
    </p>
    <div class="button-container no-select-clickable-items">
        <button class="dialog-button" mat-button (click)="onNoClick()">
            <p>{{ 'MessageDialogComponent.Deny' | translate }}</p>
        </button>
        <button class="dialog-button dialog-button-last" mat-button (click)="onTrueClick()">
            <p>{{ 'MessageDialogComponent.Accept' | translate }}</p>
        </button>
    </div>
</div>